import { InstalledModuleType } from "src/utils/constants/global-constants";

import { IOrder } from "../api/orders.api";

/**
 * Helper to return a consitant reference number across the platform
 *
 * @param order
 * @param installedModules
 * @returns
 */
export const orderReferenceNumber = (order: IOrder, installedModules: InstalledModuleType[]): string => {
  if (order.orderReference && !installedModules.includes("rjl")) {
    return order.orderReference;
  }

  return (order.id || "-").toString();
};
